import "../App.scss";
import { Routes, Route } from "react-router-dom";
import { CustomNavbar } from "../utils/elements/CustomNavbar";
import { CustomFooter } from "../utils/elements/CustomFooter";
import { Home } from "../domain/Home";

const App = () => {
  return (
    <div className="App">
      <CustomNavbar />
      <div id="main">
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </div>
      <CustomFooter />
      <a
        href="https://wa.me/56923856973"
        class="whatsapp_float"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i class="fa fa-whatsapp whatsapp-icon"></i>
      </a>
    </div>
  );
};

export default App;
